export default function ($translate) {
    return {
        KEYS: {
            HOUR: 'HOUR',
            DAY: 'DAY',
            WEEK: 'WEEK'
        },
        LABELS: {
            HOUR: $translate.instant('courses.external.Hours'),
            DAY: $translate.instant('courses.external.Days'),
            WEEK: $translate.instant('courses.external.Weeks')
        }
    };
}



// WEBPACK FOOTER //
// ./src/app/enums/course/occurrenceAccessPeriodType/index.js